
import { Component, Input, AfterViewInit } from '@angular/core';
//ne pas supprimer le ts-ignore il sert à importer leaflet sans avoir d'erreur
// @ts-ignore
import * as L from 'leaflet';

import { CoreService, HttpService } from '../services';
import { isEmptyStr } from '../utilities';


const iconRetinaUrl = 'assets/images/marker-icon-2x.png';
const iconUrl = 'assets/images/marker-icon.png';
const shadowUrl = 'assets/images/marker-shadow.png';
const iconDefault = L.icon({
  iconRetinaUrl,
  iconUrl,
  shadowUrl,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  tooltipAnchor: [16, -28],
  shadowSize: [41, 41]
});
L.Marker.prototype.options.icon = iconDefault;


@Component({
  selector: 'q-leaf-map', 
  templateUrl: './q-leaf-map.component.html',
  styleUrls: ['./q-leaf-map.component.css']
})

/**
 *  Composant qui crée une map grace à la librairie leaflet et qui utilise l'api nominatim
 *  pour trouver les coordonnées d'une adresse à partir de son nom sous forme de string
 *  url pour tester les résultats de l'api via une interface https://nominatim.openstreetmap.org/ui/search.html,
 *  url de la doc de l'api https://nominatim.org/release-docs/develop/api/Overview/
 *  doc pour changer le layer de la map https://github.com/leaflet-extras/leaflet-providers
 */
export class QLeafMapComponent implements AfterViewInit {

  // #region CONSTRUCTEUR

  constructor(private http: HttpService, private indParam: CoreService) { }
    

   // #endregion

  // #region VARIABLES GLOBALES
  
  /** Objet qui représente la carte */
  private map: L.Map;
  /**Objet qui représente les coordonnées (Latitude, Longitude en degrès) */
  private latLong: L.LatLng;
  /** @Input adresse sous forme de string */
  public Adresse: string;
  /** boolean pour savoir si les coordonnées de l'adresse on était trouvé avec l'api */
  public CoordAdressIsFind: boolean = false;
  /** boolean pour savoir si la le template html est init */
  private viewInited: boolean = false;
  /** boolean pour savoir si les datas peuvent etres init */
  private AfterViewInitHaveToInitData: boolean = false;
  /** marqueur à afficher sur la map */
  private marker: L.marker;

  public lang: string;


  /** Input qui represente l'adresse sous forme de string */
  @Input('Adresse') set SetAdresse(strAdress: string) {
    if (!isEmptyStr(strAdress)) {
      this.Adresse = strAdress;
      if (this.viewInited) {
        this.InitData();
      } else {
        this.AfterViewInitHaveToInitData = true;
      }
    }
  }

  /** Input qui represente la Culture sous forme de string pour définir la langue */
  @Input('Culture') set SetLang(culture: string) {
    if (!isEmptyStr(culture)) {
      switch (culture.toLowerCase()) {
        case 'fr-fr':
          this.lang = 'fr';
          break;
        case 'en-gb':
          this.lang = 'en';
          break;
        default:
          this.lang = 'fr;';
          break;

      }
    }
  }
  // #endregion

  // #region CYCLE DE VIE

  /** important la vue doit etre charger pour init la map via le .ts */
  ngAfterViewInit(): void {
    this.viewInited = true;
    if (this.AfterViewInitHaveToInitData) {
      this.AfterViewInitHaveToInitData = false;
      // instancie la map et le marqueur
      this.map = L.map('map');
      this.marker = L.marker()
      this.InitData();
    }
  }

  // #endregion

  // #region FONCTIONS PUBLIQUES

  // #endregion

  // #region FONCTIONS PRIVES

  /**
   *  Fonction qui initialise les coordonnées
   * */
  private async InitData() {
    // get les coordonnées (API externe) de l'adresse grace à l'adresse sous forme de string (Input)
     this.http.getHttp<any>('https://nominatim.openstreetmap.org/search?format=json&q=' + this.Adresse + '&limit=1')
       .subscribe((result: any) => {
        if (result && result[0]) {
          //Latitude, Longitude en degrès
          this.latLong = new L.LatLng(result[0].lat, result[0].lon);
         }
         this.CoordAdressIsFind = this.latLong != null && this.latLong != undefined;
         if (this.CoordAdressIsFind){
           this.initMap();
         }
      });
  }

  /**
   *  Fonction qui initialise la map
   *
   * */
  private initMap(): void | boolean {
    
    //faire un switch si il faut ajouter de nouvelles langues
    if (!this.lang) {
      // Si la langue n'est pas définie depuis l'input on la choisie par rapport à la culture
      if (this.indParam && this.indParam.AppParams) {
        this.lang =  this.indParam.AppParams.culture.toLowerCase() == "fr-fr" ? "fr" : "en";
      }
      else {
        // français par défaut
        this.lang = "fr";
      }
    }
   /* const lang: string = this.indParam.AppParams.culture.toLowerCase() == "fr-fr" ? "fr" : "en";*/
    /** verifie si la div avec l'ident 'map' existe dans le .html */
    const container = document.getElementById('map')
    if (container) {
      //set les coordonnées de la map
      this.map.setView(this.latLong, 13);
      //set le marqueur et l'ajoute à la map
      this.marker.setLatLng(this.latLong)
      this.marker.addTo(this.map);

      //instancie la popup
      var popup = L.popup({ closeButton : false })
      .setLatLng(this.latLong)
      .setContent(`<p>${this.Adresse}</p>`)
    //lie la popup au marqueur
      this.marker.bindPopup(popup).openPopup();
    // titre afficher en bas à droite (obligatoire pour utiliser la map)
      L.tileLayer(`https://tile.jawg.io/jawg-streets/{z}/{x}/{y}{r}.png?access-token=rFNTwvJrKU1LWZANisxfuPMbbLa7B6EsZoBcouCHWR4Rp1TtV506dxSfiBvIh4kz&lang=${this.lang}`, {
        maxZoom: 20,
        minZoom:1,
        attribution: "<a href=\"https://www.jawg.io\" target=\"_blank\">&copy; Jawg</a> - <a href=\"https://www.openstreetmap.org\" target=\"_blank\">&copy; OpenStreetMap</a>&nbsp;contributors",
    }).addTo(this.map);
    }
  }
  // #endregion
}
